import Index from "./components/Index";

const routes = {
  path: "dashboard/top-books-performance",
  children: [{ path: "", element: <Index /> }],
};

export default routes;
